import styled from 'styled-components';
import breakpoints, { zIndexes } from '@styles/constants.styled';

export const StyledText = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  color: var(--theme-main-color-inverse);
  text-transform: uppercase;
  transition: all 300ms ease-out;
  @media screen and ${breakpoints.Device.mobile} {
    padding-top: 10px;
  }
`;
export const StyledPageTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  color: var(--theme-main-color-inverse);
  text-transform: uppercase;
  transition: all 300ms ease-out;
  @media screen and ${breakpoints.Device.mobile} {
    ,arg
    padding-top: 10px;
  }
`;
